import React from "react";
import "./CoreServiceCard.css";
import { renderTextWithNormalDash } from "../../utils/textFormatters";

const CoreServiceCard = ({ image, title, text, dark, classes, index }) => {
    const className = {
        title: classes === "sunglasses" ? "sunglasses" : classes === "eye-exam" || classes === "safety-glasses" || classes === "contact-lenses" ? "eye-exam-title" : classes === "eye-glasses" ? "eye-glasses" : classes === "sports-goggles" ? "sports-goggles" : ""
        , text: classes === "sunglasses" ? "sunglasses" : classes === "eye-exam" || classes === "safety-glasses" || classes === "contact-lenses" ? "eye-exam-text" : classes === "eye-glasses" ? "eye-glasses" : classes === "sports-goggles" ? "sports-goggles" : ""
    }
    const position = index % 2 === 0 ? "right" : "left";
    return (
        <div className={`core-service-card position-${position}`} style={{ backgroundImage: `url(${image})` }}>
            <div className="core-service-content ">
                <h3 className={className.title}>{title}</h3>
                <p className={className.text}>{renderTextWithNormalDash(text)}</p>
            </div>
        </div>
    );
};

export default CoreServiceCard;
